import {
  Grid,
  makeStyles, Table, TableBody, TableCell, TableContainer, TableRow, Typography,
} from '@material-ui/core';
import React, {useEffect, useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import ErrorCardController from "../../UiComponents/ErrorCardController";
import {TrafficShapingService} from "../../../Domain/Services/TrafficShapingService";
import CubeMatchingEntry from "../../../Domain/Models/CubeMatchingEntry";
import GroupElement from "./GroupElement";
import {groupRepository} from "../../../Domain/Repositories/GroupRepository";
import Group from "../../../Domain/Models/Group";
import {TrafficShapingStatus} from "../../../Domain/Models/TrafficShapingStatus";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  title: {
    flexGrow: 1
  },
  headerName: {
    color: '#FFFFFF'
  },
  headerNameRed: {
    color: '#FF0000'
  },
  table: {
    tableLayout: 'fixed',
    marginBottom: '20px'
  },
  column: {
    backgroundColor: '#222222',
    verticalAlign: 'top',
    alignContent: 'center'
  },
}));

interface StatsHeaderProps
{
  trafficShapingStatus: TrafficShapingStatus;
}

export default function StatsHeader(props: StatsHeaderProps)
{
  const classes = useStyles();
  const history = useHistory();
  
  const { trafficShapingStatus } = props;

  const [time, setTime] = useState(Date.now());

  const getLastHalfHourDate = (): Date =>
  {
    const now = new Date();

    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();

    const hour = now.getHours();
    let minute = now.getMinutes();

    minute = minute < 30 ? 0 : 30;

    return new Date(year, month, day, hour, minute)
  }

  const getLastHalfHourSeconds = (): number =>
  {
    const now = new Date();

    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();

    const hour = now.getHours();
    let minute = now.getMinutes();

    minute = minute < 30 ? 0 : 30;

    return (getLastHalfHourDate().getTime() - new Date(year, month, day).getTime()) / 1000;
  }

  const formatTime = (sceonds: number): string =>
  {
    const h = Math.floor(sceonds / 3600);
    const m = Math.floor(sceonds % 3600 / 60);
    const s = Math.floor(sceonds % 3600 % 60);

    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }

  const getGroupCountForLastHalfHour = (): number =>
  {
    const lastHalfHour = getLastHalfHourDate().getTime();
    return groupRepository.groups
      .filter((x) => new Date(x.createdAt).getTime() > lastHalfHour)
      .length;
  }

  useEffect(() =>
  {
    const interval = setInterval(() => setTime(Date.now()), 5000);
    return () => {
      clearInterval(interval);
    };
  }, [])

  return (
    <>
      <TableContainer>
        <Table className={classes.table}>
          <TableBody>
            <TableRow key={1}>
              <TableCell className={classes.column} scope="row">
                <Typography className={classes.headerName} component="p" variant="body1" align='right'>
                  Groups Waiting
                </Typography>
                <Typography className={classes.headerName} component="p" variant="body2" align='right'>
                  {trafficShapingStatus.numberOfEntriesInQueue}
                </Typography>
              </TableCell>
              <TableCell className={classes.column} scope="row">
                <Typography className={classes.headerName} component="p" variant="body1" align='right'>
                  Unmatched groups
                </Typography>
                <Typography className={classes.headerName} component="p" variant="body2" align='right'>
                  {trafficShapingStatus.cubeMatchingEntries.filter(x => x.matchedCube === undefined).length}
                </Typography>
              </TableCell>
              <TableCell className={classes.column} scope="row">
                <Typography className={classes.headerName} component="p" variant="body1" align='right'>
                  Kicked Groups
                </Typography>
                <Typography className={classes.headerName} component="p" variant="body2" align='right'>
                  {trafficShapingStatus.kickedGroups.length}
                </Typography>
              </TableCell>
              <TableCell className={classes.column} scope="row">
                <Typography className={classes.headerName} component="p" variant="body1" align='right'>
                  Groups Checked-In Since {formatTime(getLastHalfHourSeconds())}
                </Typography>
                <Typography className={getGroupCountForLastHalfHour() < 9 ? classes.headerName : classes.headerNameRed} component="p" variant="body2" align='right'>
                  {getGroupCountForLastHalfHour()}
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}